<template>
  <main>
    <div class="center-wrapper">
      <div class="header-wrapper" :class="{ stage2: stage == 2 }">
        <div class="header-inner">
          <img
            :class="{ hidden: stage == 2 }"
            class="gold-bg1"
            src="./assets/images/gold_1.png"
            alt=""
          />
          <Transition name="fade-up">
            <div v-if="stage == 1" class="fade-cont">
              <img class="header-top" src="./assets/images/header_top.svg" alt="" />
              <img class="header-main" src="./assets/images/header_main.svg" alt="" />
              <img class="header-down" src="./assets/images/header_down.svg" alt="" />
            </div>
          </Transition>
          <div v-if="stage == 2" class="new-cont">
            <img class="gold-bg2" src="./assets/images/gold_1.png" alt="" />
            <img class="win-top" src="./assets/images/winbox.png" alt="" />
          </div>
        </div>
      </div>
      <Transition name="slide-fade">
        <div class="main-wrapper" v-if="stage == 1">
          <div class="main-container">
            <div class="game-container">
              <Game @win="win" :active="active" />
            </div>
          </div>
        </div>
      </Transition>
      <div class="main-wrapper2" v-if="stage == 2">
        <div class="main-container">
          <div class="cont">
            <img class="shine2" src="./assets/images/flare.png" alt="" />
            <img class="bar1" src="./assets/images/bar1.png" alt="" />
            <img class="shine1" src="./assets/images/flare.png" alt="" />
          </div>
          <img class="cudou" src="./assets/images/cadou.png" alt="" />
        </div>
        <img class="gold-banner" src="./assets/images/gold_1.png" alt="" />
        <div class="banner">
          <img class="price" src="./assets/images/cena.png" alt="" />
        </div>
        <div class="button-cont">
          <img class="arr left" src="./assets/images/arrow_fin.png" alt="" />
          <a href="https://www.casademonede.ro/vita-lui-stefan?utm_source=HFDO062024&utm_medium=EMAILING&utm_campaign=RGSCMHFEM2kolekceMESICE062024&utm_content=194826">
            <img class="button" src="./assets/images/winbtn.png" alt="" />
          </a>
          <img class="arr right" src="./assets/images/arrow_fin.png" alt="" />
        </div>
      </div>

      <Transition name="slide-fade">
        <div v-if="stage == 1" class="timer-wrapper">
          <div class="timer-inner">
            <img src="./assets/images/rest.png" class="img-rest" alt="" />
            <div class="timer-bg">
              <div class="timer">
                {{ showTime }}
              </div>
            </div>
            <a
              href="https://www.casademonede.ro/uploads/mailing/Pravidla-hry-RO-062024.pdf"
              class="rules-container"
              target="_blank"
            >
              <img src="./assets/images/rules.png" class="img-rules" alt="" />
            </a>
          </div>
        </div>
      </Transition>
    </div>
  </main>
  <div v-if="!active" class="full-screen-overlay">
    <div class="badge-container">
      <img src="./assets/images/gameover.png" class="badge" @click="resetGame()" />
    </div>
  </div>
</template>

<script setup>
import Game from './components/Game.vue'

import { ref, onMounted } from 'vue'

const stage = ref(1)
const active = ref(true)

const timer = ref(180)
const interval = ref(null)
const showTime = ref('3:00')

onMounted(() => {
  interval.value = setInterval(reduceTime, 1000)
})

const reduceTime = () => {
  timer.value -= 1
  showTime.value = secondsToMinutesAndSeconds(timer.value)
  if (timer.value == 0) {
    clearInterval(interval.value)
    // emit('game-over')
    active.value = false
  }
}

const secondsToMinutesAndSeconds = (seconds) => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60
  const formattedTime = `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
  return formattedTime
}

const resetGame = () => {
  window.location.reload()
}

const win = () => {
  stage.value = 2
  clearInterval(interval.value)
}
</script>

<style scoped></style>
